import React, { Fragment, useState } from 'react';
import ContentParser from 'src/ui/library/ContentParser';
import classNames from 'classnames';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
//import EditIcon from '@material-ui/icons/Edit';
//import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import { ConfirmDialog } from 'src/ui/library/Dialog';
//import Checkbox from 'src/ui/library/Checkbox';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { DOCUMENT_READ_ONLY_TYPES_FOR_EXT_USERS } from 'src/constants/constants';
import moment from 'moment';
import { toMoment } from 'src/helpers/date';
import WarningIcon from '@material-ui/icons/Warning';

export default function DocumentInfoPres({
  //modals
  showCancelEditlModal,
  showDeleteModal,
  onConfirmDeleteModal,
  onCancelModal,
  onConfirmModal,
  //state
  docState,
  isEditable,
  documentId,
  documentKey,
  employeeGUID,
  disableEdit,
  //actions
  onFormChange,
  onCancel,
  onEdit,
  onSave,
  onDelete,
  openDocument,
  onDocumentAccessChanged,
  // roles
  isEYPro,
  isApplicant,
  isCorpClient,
  isRestrictedCorpMember,
  isCorporateClientLineManager,
  // document permissions
  accessCorporateClient,
  accessCorporateClientLineManager,
  accessEmployee,
  accessEyProfessional,
  formData,
  isEditButtonDisabled,
}) {
  const [validationError, setValidationError] = useState(false);
  const numberOfColumns = 3;
  const formClass = classNames({
    'documents-form-detail': true,
    editmode: isEditable,
  });

  if (docState.isLoading || !formData) {
    return (
      <div style={{ marginTop: '10%', marginBottom: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  }

  if (docState.documentDetail.pageElements === undefined) {
    return null;
  }

  const data = docState.documentDetail;

  // const selDocumentTypeInForm = flattenObject(
  //   data.pageElements.filter(el => {
  //     return el.lookUpName === 'ey_documenttype' && el.entityName === 'ey_document';
  //   }),
  // );

  // const selDocumentType = flattenObject(
  //   data.lookUps['ey_documenttype'].filter(el => {
  //     return el['lookUpBindValue'] === selDocumentTypeInForm.value;
  //   }),
  // );

  DOCUMENT_READ_ONLY_TYPES_FOR_EXT_USERS.includes(docState.documentDetailType) &&
    [isApplicant, isCorpClient, isRestrictedCorpMember, isCorporateClientLineManager].includes(true) &&
    (isEditButtonDisabled = true);

  const onValidate = (fields, setErrorFn) => {
    setValidationError(false);
    const { ey_issuedate, ey_expirationdate } = fields;
    if (ey_issuedate && ey_expirationdate) {
      if (toMoment(ey_expirationdate) < toMoment(ey_issuedate)) {
        const errorMsg = (
          <span className="error-msg">
            <WarningIcon />
            <b>Expiration date cannot occur before Issue date</b>
          </span>
        );
        setErrorFn('ey_expirationdate', true, errorMsg);
        setValidationError(true);
      }
    } else if (ey_expirationdate) {
      if (toMoment(ey_expirationdate) < moment()) {
        const errorMsg = (
          <span className="error-msg">
            <WarningIcon />
            <b>Document expired</b>
          </span>
        );
        setErrorFn('ey_expirationdate', true, errorMsg);
      }
    }
  };

  return (
    <Fragment>
      {showCancelEditlModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('cases.details.buttons.cancelEdit')}
          confirmText={intl.get('cases.details.buttons.continueEdit')}
          onCancel={onCancelModal}
          onConfirm={onConfirmModal}>
          {intl.get('cases.details.messages.confirmMessage')}
        </ConfirmDialog>
      )}

      {showDeleteModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('documents.documentDetails.modals.cancelDelete')}
          confirmText={intl.get('documents.documentDetails.modals.confirmDelete')}
          onCancel={onCancelModal}
          onConfirm={onConfirmDeleteModal}>
          {intl.get('documents.documentDetails.modals.confirmMessage')}
        </ConfirmDialog>
      )}
      <div className="detail-body-inner">
        <section className={formClass}>
          <Grid item xs={12}>
            <Grid container className="documents-info-grid">
              <Grid item xs={12}>
                <div className="form-parser">
                  <ContentParser
                    key={`${isEditable}-${documentId}`}
                    readOnly={!isEditable}
                    data={data}
                    numberOfColumns={numberOfColumns}
                    showLabels={false}
                    debug={false}
                    onValidate={onValidate}
                    onChange={onFormChange}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </section>
      </div>

      <section className="documents-actions">
        {isEditable ? (
          <div className="save-cancel-wrapper">
            <Button styleType="secondary" onClick={onCancel} className="action-button">
              {intl.get('documents.documentDetails.buttons.cancel')}
            </Button>
            <Button className="action-button" onClick={onSave} disabled={!formData.isFormComplete || validationError}>
              {intl.get('documents.documentDetails.buttons.save')}
            </Button>
          </div>
        ) : (
          <Fragment>
            {/* <div className="edit-delete-wrapper">
                <a className="link" onClick={onEdit}>
                  <EditIcon className="icon" /> <span className="text">{intl.get('documents.documentDetails.buttons.edit')}</span>
                </a>
              </div> */}
            <Button styleType="secondary" onClick={onEdit} disabled={isEditButtonDisabled} className="action-button">
              <span className="text">{intl.get('documents.documentDetails.buttons.edit')}</span>
            </Button>
            <Button onClick={() => openDocument(documentKey, employeeGUID)} styleType="cmsUpload">
              <span>{intl.get('documents.documentDetails.buttons.download')}</span>
            </Button>
          </Fragment>
        )}
      </section>
    </Fragment>
  );
}
